import type { FeatureFlag } from './types';

/**
 * Check if a feature flag is enabled for the current user, either via feature cookie (if set) or by being part of a test group (not yet implemented).
 *
 * @param feature a feature flag definition object
 * @param cookies the current cookies
 * @returns `true` if the feature is enabled for the current user, `false` otherwise
 */
export const hasFeatureFlag = (feature: FeatureFlag, cookies: Record<string, string>) => {
  const hasFeatureCookie = `feature/${feature.name}` in cookies;

  // TODO getCachedTestRuleset and all that, currently pretty harsh to deal with in an isomorphic manner, and exacerbated by the async nature of the current test participation API
  const isPartOfTestGroup = feature.isPartOfTestGroup(undefined);

  return hasFeatureCookie || isPartOfTestGroup;
};
